<template>
  <div class="procard_wrap">
    <div class="procard_btn" v-scroll-animate="'slide-itemgk'">
      <div
        class="procard_item"
        v-for="(item, index) in procardList"
        :key="index"
        :class="mouseOverIndex==index? 'active' : '' || activeIndex === index ? 'active' : ''"
        @click="changeIndex(index)"
        @mouseover="mouseOverIndex=index"
        @mouseout="mouseOverIndex = null"
      >
        <a class="activeA">{{ item.tit }} </a>
      </div>
      <!-- 移动端菜单 -->
      <el-row class="mobileGkmenu">
        <el-col :xs="12" v-for="(item, index) in procardList" :key="index">
          <div  :class="activeIndex === index ? 'mobileGkdiv active' : 'mobileGkdiv'" @click="changeIndex(index)">{{ item.tit }}</div> 
        </el-col>
      </el-row>
    </div>


    <!-- <div class="module" v-scroll-animate="'fade-in'">模块111111111</div>
    <div class="module" v-scroll-animate="'slide-up'">模块22222222222222</div> -->

    <div class="thirdLine"  v-scroll-animate="'slide-itemgk'">
     
            <!-- <span class="line"></span> -->
            <div class="txt">
              <span>集团简介</span>
            </div>
            <!-- <span class="line"></span> -->
      </div>
      <div class="procard_content" id="target0">
        <div class="content_full"  v-scroll-animate="'fly-in-bottom'">
          <div class="full_txt" v-blank-link v-html="gaikuangDetail.content"></div>
           
        </div>
       </div>
    <!-- 组织架构 -->
     
    <Menu2  id="target1" class="minheighty" />


     <!-- 控股企业 -->
     <Menu5 id="target2" />

    <!-- 发展战略 -->
    <Menu3   id="target3" class="minheighty" />
    <!-- 发展历程 -->
    <div style="width: 100%;"  id="target4"> 
      <div class="thirdLine">
			 <!-- <span class="line"></span> -->
			 <div class="txt">
			   <span>发展大事记</span>
			 </div>
			 <!-- <span class="line"></span> -->
	   </div> 
     <Menu4  />
    </div>
    


     <!-- 集团荣誉 -->
     <!-- <Menu6 id="target5" /> -->

       <!-- 联系我们 -->
      <!-- <Menu7 id="target5" /> -->
     
    
  </div>
</template>

<script>
  import API from '@/api/index'

import Menu2 from '@/components/gk/menu2'
import Menu3 from '@/components/gk/menu3'
import Menu4 from '@/components/gk/menu4'
import Menu5 from '@/components/gk/menu5'
// import Menu6 from '@/components/gk/menu6'
import Menu7 from '@/components/gk/menu7'

export default {
  components: {
    Menu2,
    Menu3,
    Menu4,
    Menu5,
    // Menu6,
    Menu7
  },
  data() {
    return {
     
      activeIndex: 0,
      gaikuangDetail:{},
      mouseOverIndex:null,
      
      
    }
  },
  props: {
    procardList: {
      type: Array,
      default: [],
    },
  },
  mounted() {
     
     this.getArticleFn()

   
   },
  methods: {
    mouseOverIndex(index) {
      this.mouseOverIndex = index
    },
    
    changeIndex(index) {
      this.activeIndex = index

      let objID='target'+index
      const element = document.getElementById(objID);
      element.scrollIntoView({ 
        behavior: 'smooth', // 平滑滚动
        block: 'start'      // 对齐到顶部（可选：'center'/'end'）
      });

     
     
    },

     // 获取集团简介
      async getArticleFn() {
      try {
        let objParams={
        catId:'883069b90a844d0499b05fa8e0789079',
        pageNum:1
      }
        const res = await API.getArticle(objParams)
       this.gaikuangDetail=res.data.artList[0]
      } catch (error) {
      }
      },
  },
}
</script>

<style lang="scss" scoped>
.minheighty{
  
  min-height: 65vh;
    // justify-content: center;
    @media screen and (max-width: 768px) {
      flex-direction: column;
      min-height: auto;
    }
}
.procard_wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  // padding-bottom: 8rem;s
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;
  
  @media screen and (max-width: 768px) {
    // width: 95%;
    // padding-left: 5%;
    background: #f7f7f7;
    min-height: 60vw;
    }
  .procard_btn {
    width: 90vw;
    margin:0 auto;
    display: flex;
    .mobileGkmenu{
      display:none;
    }
     
  .procard_item {
    flex: 1;
    height: 60px;
    background: rgba(255,255,255,1);
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:1.1rem;
    position: relative;
    cursor: pointer;
    // color: #1890ff;
   
    transition: all 0.3s ease;
    @media screen and (max-width: 768px) {
        display:none;
        height: 60px;
        text-align: center;
        font-size: 12px;
        color: #1890ff;
        transition: all 0.3s ease;
      }
    }
    a{
      color: #015293;
    }
    .active {
      transform: translateY(-3px);
      // background: #2091d3;
      // background: linear-gradient(135deg, #0649b8, #03d2c5);
      // background: linear-gradient(to right, rgb(220, 241, 248),#058ad6);
      background: #015293 !important;
      box-shadow: 0 4px 15px rgba(3, 210, 197, 0.3);
      font-weight: bold;
      a{
        color: #ffffff;
      }
      
    }
    @media screen and (max-width: 768px) {
      
        .mobileGkmenu{
          display:block;
          width:100%;
          // height:10rem;
          .mobileGkdiv{
            background: rgba(255,255,255,1);
            box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
            margin:0.25rem;
            line-height:2rem;
            text-align:center;
            font-size:1rem;
          }
          .active {
            color: #fff;
            // background: linear-gradient(135deg, #0649b8, #03d2c5);
            // background: linear-gradient(to right, rgb(220, 241, 248),#058ad6);
            background: #015293 !important;
            box-shadow: 0 4px 15px rgba(3, 210, 197, 0.3);
            font-weight: bold;
            &::before {
              content: '';
            }
          }
        }
    }
  }
  .procard_content {
  
  width: 100%;
   height: auto;
  background:url('../../assets/w/img3/gaikuang/jtgk.png');
  background-size:cover;
  display: flex;
  justify-content: center;

  /* 改为上下布局 */
  .content_full {
    width: 90%;
    margin: 0 auto; // 新增：确保居中
    padding: 20px 0; // 调整padding到垂直方向
    box-sizing: border-box; // 新增：防止padding影响宽度计算
    //padding: 20px;
    
    .full_txt {
      width: 100%; // 确保文本容器充满父容器
      max-width: 100%; // 防止内容溢出
        text-indent: 2em;
        font-size: 1rem;
        line-height:2.1rem !important;
        text-align: justify !important;
        color: #333333 !important;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          line-height:1.5rem;
          padding: 0 10px; // 移动端添加适当内边距
      }
      }
  }
  @media screen and (max-width: 768px) {
    .content_full {
      width: 100%; // 移动端铺满宽度
      padding: 10px; // 调整移动端内边距
    }
  }
}
}

// .module {
//   opacity: 0;
//   height: 300px;
//   margin: 20px 0;
//   background: #f0f0f0;
//   transition: all 0.6s ease-out;
// }

// /* 动画效果 */
// .fade-in {
//   opacity: 1 !important;
// }
// .slide-up {
//   opacity: 1 !important;
//   transform: translateY(0) !important;
// }
</style>